/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Invite_X15_RetryInputs */

const en_invite_x15_retry = /** @type {(inputs: Invite_X15_RetryInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Try again`)
};

/** @type {(inputs: Invite_X15_RetryInputs) => LocalizedString} */
const ar_invite_x15_retry = en_invite_x15_retry;

/** @type {(inputs: Invite_X15_RetryInputs) => LocalizedString} */
const he_invite_x15_retry = en_invite_x15_retry;

/** @type {(inputs: Invite_X15_RetryInputs) => LocalizedString} */
const ur_invite_x15_retry = en_invite_x15_retry;

/** @type {(inputs: Invite_X15_RetryInputs) => LocalizedString} */
const es_invite_x15_retry = en_invite_x15_retry;

/** @type {(inputs: Invite_X15_RetryInputs) => LocalizedString} */
const fr_invite_x15_retry = en_invite_x15_retry;

/** @type {(inputs: Invite_X15_RetryInputs) => LocalizedString} */
const de_invite_x15_retry = en_invite_x15_retry;

/** @type {(inputs: Invite_X15_RetryInputs) => LocalizedString} */
const pt_invite_x15_retry = en_invite_x15_retry;

/** @type {(inputs: Invite_X15_RetryInputs) => LocalizedString} */
const hi_invite_x15_retry = en_invite_x15_retry;

/** @type {(inputs: Invite_X15_RetryInputs) => LocalizedString} */
const bn_invite_x15_retry = en_invite_x15_retry;

/**
* | output |
* | --- |
* | "Try again" |
*
* @param {Invite_X15_RetryInputs} inputs
* @param {{ locale?: "en" | "ar" | "he" | "ur" | "es" | "fr" | "de" | "pt" | "hi" | "bn" }} options
* @returns {LocalizedString}
*/
export const invite_x15_retry = /** @type {((inputs?: Invite_X15_RetryInputs, options?: { locale?: "en" | "ar" | "he" | "ur" | "es" | "fr" | "de" | "pt" | "hi" | "bn" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Invite_X15_RetryInputs, { locale?: "en" | "ar" | "he" | "ur" | "es" | "fr" | "de" | "pt" | "hi" | "bn" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "ar") return ar_invite_x15_retry(inputs)
	if (locale === "he") return he_invite_x15_retry(inputs)
	if (locale === "ur") return ur_invite_x15_retry(inputs)
	if (locale === "es") return es_invite_x15_retry(inputs)
	if (locale === "fr") return fr_invite_x15_retry(inputs)
	if (locale === "de") return de_invite_x15_retry(inputs)
	if (locale === "pt") return pt_invite_x15_retry(inputs)
	if (locale === "hi") return hi_invite_x15_retry(inputs)
	if (locale === "bn") return bn_invite_x15_retry(inputs)
	return /** @type {LocalizedString} */ ("Try again")
});